export default __webpack_public_path__ + "static/media/Amanita12.a8e7114f.jpg";